import uniq from 'lodash/uniq';
import t from '@instructure/quiz-i18n/es/format-message';
function hasDuplicates(a) {
  return uniq(a).length !== a.length;
}

// Performs validation against the description here: https://www.w3.org/TR/html5/forms.html#attr-input-accept
export var fileAccept = function fileAccept(files, options) {
  if (!files) return;
  var descriptions = files.split(',').map(function (str) {
    return str.trim().replace(/^\./, '');
  });
  var message = options.message || t('invalid filetype list');
  if (hasDuplicates(descriptions)) return message;
  var valid = descriptions.every(function (descr) {
    if (descr === 'audio/*') return true;
    if (descr === 'video/*') return true;
    if (descr === 'image/*') return true;
    if (descr.match(/^\w+$/)) return true;
    if (descr.match(/^\S+\/\S+$/)) return true;
    return false;
  });
  if (!valid) return message;
};
export default fileAccept;